import {Component} from '@angular/core';
import {Router, RouterOutlet} from "@angular/router";
import {animate, keyframes, query, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
  animations: [
    trigger('routeAnimations', [
      transition('* <=> *', [
        query(':enter',  [
          animate('100ms ease',
            keyframes([
              style({
                opacity: '0',
                transform: 'scale(1.1, 1.1)',
              }),
              style({
                opacity: '1',
                transform: 'scale(1, 1)',
              })
            ])
          ),
        ],
          { optional: true }),
      ]),
    ])
  ]
})
export class ShellComponent{
  constructor(
    public router: Router,
  ) {}

  prepareRoute(outlet: RouterOutlet) {
    return !outlet?.activatedRouteData || outlet.activatedRouteData.animationDisabled
      ? false
      : outlet.activatedRouteData.title
  }

}
